// Mobile drawer — vanilla JS, no Stimulus

function closeMobileMenu() {
  const drawer = document.getElementById("mobile-menu-drawer");
  const overlay = document.getElementById("mobile-menu-overlay");
  if (drawer) drawer.classList.remove("open");
  if (overlay) overlay.classList.remove("open");
  document.body.classList.remove("mobile-menu-open");
}

function openMobileMenu() {
  const drawer = document.getElementById("mobile-menu-drawer");
  const overlay = document.getElementById("mobile-menu-overlay");
  if (drawer) drawer.classList.add("open");
  if (overlay) overlay.classList.add("open");
  document.body.classList.add("mobile-menu-open");
}

// Document-level keydown registered ONCE.
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") closeMobileMenu();
});

// Reset state on BFCache restore (Turbo removed — see
// docs/LCP_OPTIMIZATION_PLAN_2026_07_06.md §3.8).
window.addEventListener("pageshow", function (event) {
  if (event.persisted) closeMobileMenu();
});

function initMobileMenu() {
  const btn = document.getElementById("mobile-menu-btn");
  const closeBtn = document.getElementById("mobile-menu-close");
  const overlay = document.getElementById("mobile-menu-overlay");
  if (!btn) return;

  // Guard against duplicate listeners on the same DOM element.
  if (btn.dataset.menuInitialized) return;
  btn.dataset.menuInitialized = "true";

  btn.addEventListener("click", openMobileMenu);
  if (closeBtn) closeBtn.addEventListener("click", closeMobileMenu);
  if (overlay) overlay.addEventListener("click", closeMobileMenu);
}

document.addEventListener("DOMContentLoaded", initMobileMenu);
